import { Practitioner } from '@medplum/fhirtypes';
import { useMedplumProfile } from '@medplum/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { QUEUE_FILTER_ANY, QUEUE_FILTERS_OFF, QueueFilterKey, QueueFilterValues } from '../services/queueFilters';
import { usePatientNavigatorOptions } from './usePatientNavigatorOptions';

/**
 * A hub tab's filter values and their defaults. PN lands you on your own
 * patients once the navigator list has loaded, if you're on it.
 *
 * @param base - The tab's other defaults (e.g. Status · Active). Pass a module
 * constant: a new object each render would reset the filters.
 */
export function useHubFilterValues(base: QueueFilterValues = QUEUE_FILTERS_OFF) {
  const profile = useMedplumProfile() as Practitioner | undefined;
  const { options: pnOptions, navigatorIds } = usePatientNavigatorOptions();
  const myPnId = profile?.id && navigatorIds.has(profile.id) ? profile.id : undefined;
  const defaults = useMemo(() => ({ ...base, pn: myPnId ?? QUEUE_FILTER_ANY }), [base, myPnId]);

  const [values, setValues] = useState<QueueFilterValues>(base);
  useEffect(() => setValues((prev) => ({ ...prev, pn: defaults.pn })), [defaults]);

  const setFilter = useCallback(
    (key: QueueFilterKey) => (value: string) => setValues((prev) => ({ ...prev, [key]: value })),
    []
  );

  return { values, setValues, setFilter, defaults, pnOptions };
}
